import { useEffect, useState } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { BotAvatar } from "./BotAvatar";
import "../../assets/styles/chat-message.css";

export const Thinking = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setIsVisible(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div className="mx-4 flex flex-col justify-end">
      <div
        className={classNames(
          "flex flex-row items-center gap-3 transition-opacity duration-300 ease-out",
          isVisible ? "opacity-100" : "opacity-0",
        )}
      >
        <BotAvatar />
        <div className="bg-secondary rounded-2xl px-3 py-2">
          <div className="typing flex items-center gap-1">
            <span className="inline-block size-1 rounded-full bg-[#717680]" />
            <span className="inline-block size-1.5 rounded-full bg-[#717680]" />
            <span className="inline-block size-2 rounded-full bg-[#717680]" />
          </div>
        </div>
      </div>
    </div>
  );
};
